import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';

/**
 * Contract for setting/updating user alias.
 */
@ApiContract({ endpoint: Api.setAlias, httpMethod: HttpMethods.put })
export class ApiSetAlias {
  constructor(readonly alias: string) {}
}
